export default __webpack_public_path__ + "static/1-929b7925e794d4ae1a3bcf24139285dc.png";